import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { DonateProvider } from "./contexts/DonateContext.jsx";
import HomePage from "./pages/HomePage.jsx";
import DonationsPage from "./pages/DonationsPage.jsx";
import JaxPartnershipPage from "./pages/JaxPartnershipPage.jsx";
import RespitePartnershipPage from "./pages/RespitePartnershipPage.jsx";
import TermsOfUsePage from "./pages/TermsOfUsePage.jsx";
import PrivacySecurityPage from "./pages/PrivacySecurityPage.jsx";

export default function App() {
  return (
    <DonateProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/donations" element={<DonationsPage />} />
          <Route path="/impact/JAX" element={<JaxPartnershipPage />} />
          <Route path="/impact/Respite" element={<RespitePartnershipPage />} />
          <Route path="/terms-of-use" element={<TermsOfUsePage/>} />
          <Route path="/privacy-and-security" element={<PrivacySecurityPage/>} />
        </Routes>
      </Router>
    </DonateProvider>
  );
}
